// Etiqueta de existencias de la tienda online del súper (PR 2a; la pinta 2b).
//
// Pura: recibe lo que devuelve POST /api/online-orders/retail-stock y decide si el
// producto va «Agotado», «Quedan N» o sin etiqueta.

/** Umbral por defecto de «quedan pocas» cuando el producto no define uno. */
export const DEFAULT_LOW_STOCK_THRESHOLD = 5

export type StockBadge = { kind: "sold_out" } | { kind: "low"; left: number } | null

/**
 * `available` null = el producto no controla stock → sin etiqueta.
 * `low` cuando quedan `<= (threshold ?? 5)`; `sold_out` cuando no queda nada.
 */
export function stockBadge(available: number | null, threshold: number | null): StockBadge {
  if (available === null) return null
  if (available <= 0) return { kind: "sold_out" }
  if (available <= (threshold ?? DEFAULT_LOW_STOCK_THRESHOLD)) return { kind: "low", left: available }
  return null
}
